import CreateStoreSettingsForm from './CreateStoreSettingsForm';

export default CreateStoreSettingsForm;
